export const isCatalogueAvailableForTrack = (
	user: User | null | undefined,
	track: Track | undefined
): boolean => {
	if (!user) {
		return true
	}

	const catalogueId = track?.album.catalogue.id

	if (catalogueId === undefined) {
		return false
	}

	return user.viewableCatalogues.includes(catalogueId)
}
